/*
 * Agency Settings — top-level page collecting agency-wide configuration
 * under one tabbed shell. Roles & Permissions is the first tab (iter183);
 * more tabs come as we consolidate scattered agency-level settings.
 */
import { useState } from "react";
import { PageHeader } from "../components/Primitives";
import { RolesPermissionsTab } from "../components/agency-settings/RolesPermissionsTab";
import { AlertsTab } from "../components/agency-settings/AlertsTab";
import { ClientPortfoliosTab } from "../components/agency-settings/ClientPortfoliosTab";

const TABS = [
  { id: "roles", label: "Roles & Permissions", testid: "tab-roles" },
  { id: "alerts", label: "Alerts & Notifications", testid: "tab-alerts" },
  { id: "portfolios", label: "Client Portfolios", testid: "tab-portfolios" },
];

export default function AgencySettings() {
  const [tab, setTab] = useState("roles");

  return (
    <div>
      <PageHeader
        title="Agency Settings"
        subtitle="Configure how this agency operates: roles, permissions, and more."
      />
      <div className="p-8 space-y-4">
        <div className="border-b border-[#27272A]">
          <div className="flex gap-1">
            {TABS.map((t) => {
              const active = tab === t.id;
              return (
                <button
                  key={t.id}
                  data-testid={t.testid}
                  onClick={() => setTab(t.id)}
                  className={`px-4 py-2 text-xs uppercase tracking-widest transition-colors border-b-2 ${
                    active
                      ? "border-[#FF3B30] text-[#FF3B30]"
                      : "border-transparent text-zinc-400 hover:text-white"
                  }`}
                >{t.label}</button>
              );
            })}
          </div>
        </div>
        {tab === "roles" && <RolesPermissionsTab />}
        {tab === "alerts" && <AlertsTab />}
        {tab === "portfolios" && <ClientPortfoliosTab />}
      </div>
    </div>
  );
}
